export const ui = {
  page: { flex: 1, padding: '54px 16px 100px' },
  container: { maxWidth: 980, margin: '0 auto' },
  backBtn: {
    background: 'none',
    border: 'none',
    color: '#67e8f9',
    cursor: 'pointer',
    fontWeight: 700,
    marginBottom: 14,
    letterSpacing: '0.02em',
    textShadow: '0 0 12px rgba(34,211,238,0.35)',
  },
  card: {
    background: 'linear-gradient(180deg, rgba(15,23,42,0.78) 0%, rgba(2,6,23,0.8) 100%)',
    border: '1px solid rgba(34,211,238,0.28)',
    borderRadius: 16,
    padding: 20,
    boxShadow: '0 0 0 1px rgba(34,211,238,0.08) inset, 0 12px 28px rgba(2,132,199,0.15)',
    backdropFilter: 'blur(6px)',
  },
  sectionTitle: { margin: '0 0 8px', color: '#f8fafc', fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em' },
  sectionSub: { margin: 0, color: '#94a3b8', lineHeight: 1.6 },
  label: { display: 'block', color: '#cbd5e1', fontSize: 12, fontWeight: 700, letterSpacing: '0.05em', marginBottom: 8, textTransform: 'uppercase' },
  input: {
    width: '100%',
    padding: '11px 12px',
    borderRadius: 10,
    border: '1px solid rgba(56,189,248,0.35)',
    background: 'rgba(2,6,23,0.72)',
    color: '#e2e8f0',
    outline: 'none',
    boxShadow: 'inset 0 0 0 1px rgba(15,23,42,0.45)',
  },
  textarea: {
    width: '100%',
    borderRadius: 10,
    border: '1px solid rgba(56,189,248,0.35)',
    background: 'rgba(2,6,23,0.72)',
    color: '#e2e8f0',
    padding: 12,
    outline: 'none',
    boxSizing: 'border-box',
    boxShadow: 'inset 0 0 0 1px rgba(15,23,42,0.45)',
  },
  select: {
    width: '100%',
    padding: '11px 12px',
    borderRadius: 10,
    border: '1px solid rgba(56,189,248,0.35)',
    background: 'rgba(2,6,23,0.72)',
    color: '#e2e8f0',
    outline: 'none',
    boxShadow: 'inset 0 0 0 1px rgba(15,23,42,0.45)',
  },
  fileInput: {
    width: '100%',
    padding: '11px 12px',
    borderRadius: 10,
    border: '1px dashed rgba(56,189,248,0.5)',
    background: 'rgba(2,6,23,0.55)',
    color: '#cbd5e1',
    boxSizing: 'border-box',
  },
  primaryBtn: {
    padding: '10px 14px',
    borderRadius: 10,
    border: '1px solid rgba(34,211,238,0.65)',
    background: 'linear-gradient(180deg, rgba(6,182,212,0.25), rgba(8,47,73,0.45))',
    color: '#67e8f9',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 0 18px rgba(6,182,212,0.2)',
  },
  secondaryBtn: {
    padding: '10px 14px',
    borderRadius: 10,
    border: '1px solid rgba(148,163,184,0.4)',
    background: 'rgba(15,23,42,0.75)',
    color: '#cbd5e1',
    fontWeight: 700,
    cursor: 'pointer',
  },
  error: { marginTop: 10, color: '#fca5a5', fontSize: 13 },
  success: { marginTop: 10, color: '#86efac', fontSize: 13 },
  mono: { fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' },
};
